import axios from 'axios';
import * as permissions from '../auth/permissions';

const POLICY_TO_PERMISSION = {
    ReadCSASummary: permissions.READ_CSA_SUMMARY,
    ExecuteIMImpact: permissions.EXECUTE_IMPACT_ANALYSIS,
    WriteIMStatic: permissions.READ_STATIC_DATA,
    ExecuteJobs: permissions.EXECUTE_WEB_JOBS,
};

export const fetchPermissions = () =>
    axios.get('/SystemInfo/GetUserRole')
        .then(r => r.data.map(({ role }) => POLICY_TO_PERMISSION[role]).filter(Boolean));
